import { Link } from 'react-router-dom'

function HeroArea() {
  const scrollTop =()=>window.scrollTo({top:0,behavior:"smooth"})
  return (
    <>
     <section className="hero-area">
        <meta itemProp="name" content="Software a la medida, cloud AWS y agentes de IA | Gekkonect México" />
        <meta itemProp="description" content="Partner de plataforma: software empresarial a medida, integraciones, SaaS, infraestructura AWS y Gekko-AI para escalar con control. Puebla · México." />
        <div className="verticale-social">
          <ul className="vertical-media">      
            <li><a href="https://www.linkedin.com/company/gekkonect" target="_blank" rel="noopener noreferrer" aria-label="Linkedin">Linkedin</a></li>
            <li><a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">Facebook</a></li>
            <li><a href="https://x.com/gekkonectAI" target="_blank" rel="noopener noreferrer" aria-label="X">X</a></li>
          </ul>
        </div>
        
        <div className="hero-wrapper">
          <div className="container hero-main-container">
            <div className="row">
              <div className="col-lg-12">
                <div className="hero-content">                  
                  <h1 className="main-heading" itemProp="headline">
                    Software a la medida, cloud AWS y <span>agentes de inteligencia artificial</span>
                  </h1>
                  
                  <p>
                    Gekkonect actúa como <strong>partner de ingeniería y plataforma</strong>: desde el diagnóstico hasta producción—aplicaciones web, integraciones ERP/CRM, APIs, microservicios, SaaS y <strong>automatización con IA</strong> (Gekko-AI)—con métricas, seguridad y continuidad operativa.
                  </p>
                  
                  <p>
                    Trabajamos con equipos que buscan resultados medibles: menos fricción operativa, más trazabilidad y arquitectura lista para escalar. <strong>Base en Puebla; proyectos en todo México.</strong>
                  </p>

                  {/* <p className="benefits-list">
                    <br /><strong>Software 100% personalizado</strong> para tus necesidades específicas
                    <br /><strong>Integración de IA</strong> que automatiza y optimiza procesos
                    <br /><strong>Desarrollo ágil</strong> con metodologías probadas
                    <br /><strong>Soporte continuo</strong> y mantenimiento post-implementación
                  </p> */}
                  
                  <div className="buttons">
                    <div className="cmn-btn">
                      <div className="line-1" />
                      <div className="line-2" />
                      <Link 
                        to={`${process.env.PUBLIC_URL}/about`} 
                        onClick={scrollTop}
                        title="Conoce nuestra empresa de desarrollo de software"
                        aria-label="Sobre Gekkonect - Expertos en software a medida"
                      >
                        <strong>Equipo</strong>
                      </Link>
                    </div>
                    <div className="cmn-btn layout-two">
                      <div className="line-1" />
                      <div className="line-2" />
                      <Link 
                        to={`${process.env.PUBLIC_URL}/service`} 
                        onClick={scrollTop}
                        title="Servicios de desarrollo de software e Inteligencia Artificial"
                        aria-label="Servicios de desarrollo tecnológico"
                      >
                        <strong>Servicios de Software</strong>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-lg-6" /> */}
            </div>
          </div>
        </div>
        
        <div style={{display: 'none'}} itemScope itemType="https://schema.org/Organization">
          <meta itemProp="name" content="Gekkonect" />
          <meta itemProp="description" content="Software empresarial a medida, cloud AWS, integraciones y agentes de IA (Gekko-AI) para empresas en México" />
          <meta itemProp="url" content="https://www.gekkonect.com" />
          <div itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
            <meta itemProp="addressLocality" content="Puebla" />
            <meta itemProp="addressRegion" content="Puebla" />
          </div>
          <meta itemProp="telephone" content="+52 2222932256" />
        </div>

        <div style={{display: 'none'}} itemScope itemType="https://schema.org/Service">
          <meta itemProp="serviceType" content="Desarrollo de software a medida" />
          <meta itemProp="provider" content="Gekkonect" />
          <meta itemProp="areaServed" content="México" />
          <meta itemProp="description" content="Desarrollo de aplicaciones web, móviles y sistemas empresariales con Inteligencia Artificial integrada" />
        </div>
      </section>   
    </>
  )
}

export default HeroArea